export default {
	meta: {
		title: 'Gestion IDEL',
		description: 'Gérer les IDEL et en ajouter de nouveaux'
	}
};
